<div class="cap-alerts-settings-tab tw-flex tw-flex-col tw-gap-6">
  <section
    class="tw-flex tw-flex-col tw-gap-2"
    aria-labelledby="capDistributionHeading"
  >
    <h4 id="capDistributionHeading" class="cap-alerts-settings-tab__label">
      Distribution
    </h4>
    <distribution-selector
      [distribution]="settings().distribution"
      (distributionChange)="patch({ distribution: $event })"
      [distributeToAll]="settings().distributeToAll"
      (distributeToAllChange)="patch({ distributeToAll: $event })"
      [subcompanyDistribution]="settings().subcompanyDistribution"
      (subcompanyDistributionChange)="patch({ subcompanyDistribution: $event })"
      [distributeToSubcompanies]="settings().distributeToSubcompanies"
      (distributeToSubcompaniesChange)="
        patch({ distributeToSubcompanies: $event })
      "
      [subcompanyDistributeToAll]="settings().subcompanyDistributeToAll"
      (subcompanyDistributeToAllChange)="
        patch({ subcompanyDistributeToAll: $event })
      "
      [enableSubcompanies]="true"
      [enableSubcompanyDistributeToAll]="true"
      [enableFeatureCheck]="false"
      [readonly]="pageService.readOnly()"
      [showLabel]="false"
      [sentenceCaseCount]="true"
      inputId="-alerts"
    />
  </section>

  <section class="tw-flex tw-flex-col tw-gap-2">
    <label class="cap-alerts-settings-tab__label" for="defaultExpiryInput"
      >Alert duration</label
    >
    <mat-form-field
      class="cap-alerts-settings-tab__duration"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <input
        matInput
        id="defaultExpiryInput"
        type="number"
        min="0"
        [value]="settings().defaultExpiry"
        [disabled]="pageService.readOnly()"
        (input)="onDefaultExpiryInput($event)"
        (keydown)="onDefaultExpiryKeydown($event)"
      />
      <span matTextSuffix class="cap-alerts-settings-tab__suffix">Minutes</span>
    </mat-form-field>
  </section>

  <section
    class="tw-flex tw-flex-col tw-gap-2"
    aria-labelledby="capContentHeading"
  >
    <div class="tw-flex tw-flex-col tw-gap-1">
      <h4 id="capContentHeading" class="cap-alerts-settings-tab__label">
        Content
      </h4>
      <p class="cap-alerts-settings-tab__helper">
        Which parts of the alert are displayed and whether sound is played.
      </p>
    </div>
    <div class="tw-flex tw-flex-col">
      @for (item of textFieldOptions; track item.key) {
        <mat-checkbox
          [id]="'textFieldsCheckbox-' + item.key"
          [checked]="isTextFieldChecked(item.key)"
          [disabled]="pageService.readOnly()"
          (change)="setTextField(item.key, $event.checked)"
          >{{ item.label }}</mat-checkbox
        >
      }
    </div>
    <mat-slide-toggle
      id="enable-audio"
      [checked]="!!settings().enableAudio"
      [disabled]="pageService.readOnly()"
      (change)="patch({ enableAudio: $event.checked })"
      >Play alert sound</mat-slide-toggle
    >
  </section>

  <section
    class="tw-flex tw-flex-col tw-gap-2"
    aria-labelledby="capFiltersHeading"
  >
    <h4 id="capFiltersHeading" class="cap-alerts-settings-tab__label">
      Filters
    </h4>
    <div>
      <button
        rv-button
        variant="secondary"
        id="editFiltersButton"
        type="button"
        [disabled]="pageService.readOnly()"
        (click)="editFilters()"
      >
        Edit filters
      </button>
    </div>
  </section>
</div>
